module.exports = __webpack_public_path__ + "img/card-FFEDC1.d034006b.png";